import {
  RevenueClassification,
  RevenueRecognitionMethod
} from 'common/types/revenueRecognition.types'
import { RateDisplay } from 'Invoices/types'

export const LINE_ITEM_NAME_MAX_LENGTH: number = 256
export const LINE_ITEM_DESCRIPTION_MAX_LENGTH: number = 256

export const DEFAULT_QUANTITY: string = '1'
export const DEFAULT_RATE_DISPLAY: RateDisplay = 'ABSOLUTE'
export const DEFAULT_REVENUE_RECOGNITION_METHOD: RevenueRecognitionMethod =
  'POINT_IN_TIME'
export const DEFAULT_REVENUE_CLASSIFICATION: RevenueClassification = 'EARNED'
